import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaProgressoCurso = (): TabelaColuna => ({
  Chave: 'progresso',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Progresso Curso</div>
})
